<template>
    <div class="AccountSearch">
        <Row :gutter="4">
            <Col span="4">
                <Select v-model="accountTypeSearchKey" filterable :placeholder="$t('alarms.common.filterByAccountType')" :transfer="true">
                    <Option value=" " >{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <Select v-model="monitorModule" clearable filterable :placeholder="$t('configuration_management.common.monitorModule')" :transfer="true" @on-change="changeMonitorModule">
                    <Option :value="item.id" v-for="item in monitorModuleList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <Select v-model="monitorIndex" clearable filterable :placeholder="$t('alarms.common.monitorIndex')" :transfer="true">
                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="6">
                <div style="display: flex; align-items: center; flex-wrap: nowrap;">
                    <Button type="primary" @click="search" style="margin-right: 3px;">{{$t('message.select')}}</Button>
                    <add-or-update-default-alarm-configuration></add-or-update-default-alarm-configuration>
                </div>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdateDefaultAlarmConfiguration from '../default_alarm_configuration/AddOrUpdateDefaultAlarmConfiguration'
    import TableDefaultAlarmConfiguration from '../default_alarm_configuration/TableDefaultAlarmConfiguration'
    var tableDefaultAlarmConfiguration = TableDefaultAlarmConfiguration;
    export default {
        name: 'DefaultAlarmConfigurationSearch',
        components: {
            AddOrUpdateDefaultAlarmConfiguration
        },
        data () {
            return {
                accountTypeSearchKey:'',
                accountTypeList:[],
                monitorModule: '',
                monitorModuleList: [],
                monitorIndex: '',
                monitorIndexList: []
            }
        },
        mounted: function(){
            this.getAccountType();
            this.getMonitorModuleList();
            this.getMonitorIndexList();
            this.search();
        },
        methods: {
            //查询账户类型
            getAccountType: function(){
                this.$api.account.queryCloudPlatforms("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.accountTypeList = res.data;
                    })
            },
            // 查询监控模块
            getMonitorModuleList: function(){
                this.$api.alertRule.searchMonitorModuleByDefault("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.monitorModuleList = res.data;
                    })
            },
            // 查询监控指标（按监控模块过滤）
            getMonitorIndexList: function(){
                this.$api.alertRule.searchDefaultMonitorIndexByModule(this.monitorModule)
                    .then(res => {
                        this.monitorIndexList = res.data;
                    })
            },
            // 切换监控模块时联动刷新监控指标
            changeMonitorModule: function(){
                this.monitorIndex = '';
                this.getMonitorIndexList();
            },
            // 查询
            search: function(){
                eventBus.$emit('accountTypeNames', this.accountTypeSearchKey || null);
                eventBus.$emit('monitorModule', this.monitorModule);
                eventBus.$emit('monitorIndex', this.monitorIndex);
                tableDefaultAlarmConfiguration.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .AccountSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/default_alarm_configuration/DefaultAlarmConfigurationSearch.vue